import {
  differenceInDays,
  isAfter,
  isEqual,
  isSameDay,
  startOfDay,
} from 'date-fns';

import { convertToNumber } from '»utils/number';

export const addDays = (date, days) => {
  const dateCopy = new Date(date);
  dateCopy.setDate(date.getDate() + convertToNumber(days));
  return dateCopy;
};

export const dateToString = (value) => {
  const fullYear = value.getFullYear();
  const month = `0${value.getMonth() + 1}`.slice(-2);
  const day = value.getDate();
  const hour = `0${value.getHours()}`.slice(-2);
  const minutes = `0${value.getMinutes()}`.slice(-2);
  const seconds = `0${value.getSeconds()}`.slice(-2);

  return `${fullYear}-${month}-${day}T${hour}:${minutes}:${seconds}`;
};

export const isTodayAfterGivenDate = (dateToCheck) => {
  const today = startOfDay(new Date());
  const givenDate = startOfDay(new Date(dateToCheck));

  return isAfter(today, givenDate);
};

export const isTodayEqualOrAfterGivenDate = (dateToCheck) => {
  const today = startOfDay(new Date());
  const givenDate = startOfDay(new Date(dateToCheck));

  return isAfter(today, givenDate) || isEqual(today, givenDate);
};

export const isWithinDaysAfterToday = (dateToCheck, daysThreshold) => {
  const today = startOfDay(new Date());
  const givenDate = startOfDay(new Date(dateToCheck));

  if (isSameDay(givenDate, today) || isAfter(givenDate, today)) {
    const daysDifference = differenceInDays(givenDate, today);
    return daysDifference <= daysThreshold;
  }

  return false;
};
